module.exports = __webpack_public_path__ + "static/media/pencil-edit-icon.0c7eb2cc.svg";